import { ReactComponent as FlagIcon } from "./svg/cz-flag.svg";
import "../flag-icon.scss";

export const CZFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
